import { canvasArtworks, type CanvasArtwork } from "../data/canvasArtworks";
import { aiArtworks, type AiArtwork } from "../data/aiArtworks";
import { digitalArtworks, type DigitalArtwork } from "../data/digitalArtworks";
import type { ArtworkMedium } from "../lib/artworkPaths";

export type ResolvedArtwork =
  | { medium: "canvas"; work: CanvasArtwork }
  | { medium: "ai"; work: AiArtwork }
  | { medium: "digital"; work: DigitalArtwork };

export function resolveCanvasArtwork(id: string): CanvasArtwork | undefined {
  return canvasArtworks.find((work) => work.id === id);
}

export function resolveAiArtwork(id: string): AiArtwork | undefined {
  return aiArtworks.find((work) => work.id === id);
}

export function resolveDigitalArtwork(id: string): DigitalArtwork | undefined {
  return digitalArtworks.find((work) => work.id === id);
}

export function resolveArtwork(
  medium: ArtworkMedium,
  id: string,
): ResolvedArtwork | null {
  if (medium === "canvas") {
    const work = resolveCanvasArtwork(id);
    return work ? { medium, work } : null;
  }
  if (medium === "ai") {
    const work = resolveAiArtwork(id);
    return work ? { medium, work } : null;
  }
  const work = resolveDigitalArtwork(id);
  return work ? { medium, work } : null;
}

/** Legacy `/artwork/:id` — digital works only. */
export function findArtworkById(id: string): ResolvedArtwork | null {
  const digital = resolveDigitalArtwork(id);
  if (digital) return { medium: "digital", work: digital };
  const canvas = resolveCanvasArtwork(id);
  if (canvas) return { medium: "canvas", work: canvas };
  const ai = resolveAiArtwork(id);
  if (ai) return { medium: "ai", work: ai };
  return null;
}
